import { Box, Typography, Button } from '@material-ui/core'
import { Link } from 'react-router-dom'

const CompleteSlide = () => {
  return <>
    <Box>
      <Box marginBottom={2}>
        <Typography variant="h4">
          Thank you for taking the exam!
        </Typography>
      </Box>
      <Box marginBottom={2}>
        <Typography variant="subtitle1">
          The scores will be available after the exam has been reviewed. You may now close this window.
        </Typography>
      </Box>
      <Box>
        <Link to={`/examinations`}>
          <Button variant="contained" color="primary">
            Examination Dashboard
          </Button>
        </Link>
      </Box>
    </Box>
  </>
}

export default CompleteSlide